import useFetchStatic from "@/hooks/useFetchStatic"
import { useSnapshot } from "valtio"
import { store } from "@/stores/stores"
import FormField from "./FormField"
import { UseFormReturn } from "react-hook-form"
import Combobox from "../ui/combobox"
import { CommandItem } from "../ui/command"
import { Link } from "react-router"
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "../ui/dropdown-menu"

interface SelectCredentialsProps {
  form: UseFormReturn<any, any, undefined>
  node_type: string
}

function SelectCredentials(props: SelectCredentialsProps) {
  useFetchStatic(["credential"])
  const snap = useSnapshot(store)
  const nodeDef = store.scenario.nodeDefinitions.record[props.node_type]
  // const value = useWatch({ name: "credentials_id" })
  const credentials = snap.credential.list.filter((cred) => cred.type?.split(":")[0] === props.node_type)

  return (
    <FormField form={props.form} name="credentials_id" label="Credentials to connect with">
      <Combobox
        fluid
        options={
          credentials.map((cred) => {
            const credMeta = store.credential.credentialsMeta.record[cred.type]
            return { label: cred.name, value: cred.id, description: credMeta?.label }
          }) || []
        }
        placeholder="Select credentials..."
        after={
          <Link
            to={{
              hash: "settings/credentials",
            }}
          >
            <CommandItem className="shadow-node py-2 hover:shadow-none">
              <IconHugeiconsPlusSign className="size-3 [&_path]:stroke-3 text-primary" />
              Add new credential
            </CommandItem>
            {/* <DropdownMenu>
            <DropdownMenuTrigger className="rounded-full">
              <CommandItem className="shadow-node py-2 hover:shadow-none">
                <IconHugeiconsPlusSign className="size-3 [&_path]:stroke-3 text-primary" />
                Add new credential
              </CommandItem>
            </DropdownMenuTrigger>
            <DropdownMenuContent>
              {nodeDef?.credentials?.map((cred) => (
                <Link
                  to={{
                    hash: "settings/credentials/create/connection/" + cred.type,
                  }}
                >
                  <DropdownMenuItem>{cred.label}</DropdownMenuItem>
                </Link>
              ))}
            </DropdownMenuContent>
          </DropdownMenu> */}
          </Link>
        }
      />
      {/* <Select>
        <SelectTrigger className="w-full">
          <SelectValue placeholder="Select credentials...">
            {snap.credential.list.find((cred) => cred.id === value)?.name || ""}
          </SelectValue>
        </SelectTrigger>
        <SelectContent className="w-full">
          {credentials.map((cred) => {
            const credMeta = store.credential.credentialsMeta.record[cred.type]
            return (
              <SelectItem value={cred.id} key={cred.id}>
                <div className="flex flex-col">
                  <span className={cn("text-sm font-medium")}>{cred.name}</span>
                  <span className="text-[11px] text-fg-tertiary">{credMeta?.label}</span>
                </div>
              </SelectItem>
            )
          })}
        </SelectContent>
      </Select> */}
    </FormField>
  )
}

export default SelectCredentials
